'use client';

import React from 'react';
import { Reaction } from './types';

interface ReactionBarProps {
  reactions: Reaction[];
  isMe?: boolean;
}

export default function ReactionBar({ reactions, isMe = false }: ReactionBarProps) {
  if (!reactions || reactions.length === 0) return null;

  const pillStyle = isMe
    ? {
        background: 'rgba(46, 130, 220, 0.55)',
        border: '1px solid rgba(100, 180, 255, 0.35)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      }
    : {
        background: 'rgba(38, 53, 72, 0.92)',
        border: '1px solid rgba(255,255,255,0.10)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      };

  return (
    <div className="flex items-center gap-px animate-reaction-pop" role="group" aria-label="Message reactions">
      {reactions.map((r) => (
        <div
          key={`reaction-${r.emoji}`}
          className="flex items-center gap-px rounded-full cursor-pointer hover:scale-110 transition-transform duration-150 active:scale-95 select-none"
          style={{ ...pillStyle, padding: '1px 5px' }}
          role="button"
          tabIndex={0}
          aria-label={`${r.emoji} reaction, ${r.count} ${r.count === 1 ? 'person' : 'people'}`}
          title={`${r.count} reaction${r.count > 1 ? 's' : ''}`}
        >
          <span style={{ fontSize: '10px', lineHeight: 1 }}>{r.emoji}</span>
          {r.count > 1 && (
            <span className="font-medium leading-none" style={{ fontSize: '9px', color: isMe ? 'rgba(200,230,255,0.9)' : '#91A3B7' }}>{r.count}</span>
          )}
        </div>
      ))}
    </div>
  );
}